
import React from 'react'
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi' 
import Slider from "react-slick"; 
export const SectionApp = () => {
 
    const [settings] = React.useState({
        arrows:true,
        dots:true,
        infinite: true,
        speed: 500,
        autoplaySpeed: 9000,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true,
        centerMode: true,
        className: "zooom",
        centerPadding: "60px",
        swipeToSlide:true,
        pauseOnHover:false,
        swipe:true,
        prevArrow:<button type="button" className="slick-next"><FiChevronLeft /></button>,
        nextArrow:<button type="button" className="slick-next"><FiChevronRight /></button>,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
    })
    return (
        <div className="sectionapp">
             <div className="appscreens">
                <Slider {...settings}>
                    {
                      Array.from(Array(17)).map((item,i)=>(
                    <img src={`/assets/images/phones/phone${i===0?1:++i}.png`} className="screen" key={`phone-${i}`} alt="" />
                      ))
                    }
                </Slider>

            </div>
            <div className="clearfix"></div>
        </div>
    );
}
